import VTable from '@/vuetify_custom/v-table/v3'
import {getUnusualOrderListApi} from '../services'
import ViewerItem from '../item';

const fin_bills_hash = { // 比较特殊的三种单据
  FinReceiptBill: 'receipt_bills',
  FinReceiptAccrualBill: 'receipt_accrual_bills',
  FinReceivableBill: 'receivable_bills'
}

  export default {
    props: {
      model_id: {
        type: Number,
      },
      viewerParams: {
        type: Object
      }
    },
    data() {
      return {
        list: [
          {
            uid: 'xxxxxxx'
          }
        ],
        loading: false
      }
    },
    computed: {
      table_fields() {
        return [
          {
            text: '单据编号',
            align: 'center',
            value: 'uid',
            renderv: (h, val, row) => {
              const type = fin_bills_hash[row.link_model_type]
              if (type) {
                return h(ViewerItem, {
                  props: {
                    model_id: row.link_model_id,
                    type: 'ReceiptDocumentRelations',
                    receipt_type: type,
                  },
                  class: {
                    link: true
                  }
                }, val);
              }
                return h(ViewerItem, {
                  props: {
                    type: row.link_model_type,
                    model_id: row.link_model_id,
                    tip: false
                  },
                  class: {
                    link: true
                  }
                }, val);
            }   
          },
          {
            text: '处理时长',
            align: 'center',
            value: 'used_time',
           //  width: 80,
          },
          {
            text: '平均时长',
            align: 'center',
            value: 'mean_time',
           //  width: 80,
          }
        ]
      }
    },
    created() {
    
    },
    mounted() {
      const p = this.viewerParams || {}
      this.getList({
        node_id:p.flow_node_id,
        month: p.month,
        customer_id: p.customer_id
      })
      //
    },
    methods: {
      getList(params) {
        const p = this.viewerParams || {}
        getUnusualOrderListApi(params).then(res => {
         this.list = (res || []).map(i => {
           return {
             ...i,
             mean_time: p.mean_time
           }
         })
        })
      },
    },
    render() {
      const p = this.viewerParams || {}
      return <div>
        <h3>{p.account}-{p.month}</h3>
        <VTable
            headers={this.table_fields}
            desserts = {this.list}
        />
      </div>
    }
  }